var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalBgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 130,
    viewBox: "0 0 343 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6845C0 6.12678 6.12678 0 13.6845 0H328.429C335.987 0 342.114 6.12678 342.114 13.6845V130.003H0V13.6845Z",
    fill: "url(#paint0_linear_1098_1863)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6846 0.570312H328.429C335.672 0.570312 341.543 6.44171 341.543 13.6846V129.433H0.570312V13.6846C0.570312 6.44171 6.44171 0.570312 13.6846 0.570312Z",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 1.14038
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1098_1863",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 343,
    height: 131
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6845C0 6.12678 6.12678 0 13.6845 0H328.429C335.987 0 342.114 6.12678 342.114 13.6845V130.003H0V13.6845Z",
    fill: "url(#paint1_linear_1098_1863)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6846 0.570312H328.429C335.672 0.570312 341.543 6.44171 341.543 13.6846V129.433H0.570312V13.6846C0.570312 6.44171 6.44171 0.570312 13.6846 0.570312Z",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 1.14038
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1098_1863)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.828,
    y: 43.7982,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 103.828 43.7982)",
    stroke: "url(#paint2_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.828,
    y: 0.463268,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 103.828 0.463268)",
    stroke: "url(#paint3_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.828,
    y: 87.4281,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 103.828 87.4281)",
    stroke: "url(#paint4_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.109,
    y: 43.7982,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 147.109 43.7982)",
    stroke: "url(#paint5_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.109,
    y: 0.463268,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 147.109 0.463268)",
    stroke: "url(#paint6_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.109,
    y: 87.4281,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 147.109 87.4281)",
    stroke: "url(#paint7_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.391,
    y: 43.7982,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 190.391 43.7982)",
    stroke: "url(#paint8_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.391,
    y: 0.463268,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 190.391 0.463268)",
    stroke: "url(#paint9_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.391,
    y: 87.4281,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 190.391 87.4281)",
    stroke: "url(#paint10_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.828,
    y: 43.7982,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 233.828 43.7982)",
    stroke: "url(#paint11_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.828,
    y: 0.463268,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 233.828 0.463268)",
    stroke: "url(#paint12_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.828,
    y: 87.4281,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 233.828 87.4281)",
    stroke: "url(#paint13_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.109,
    y: 43.7982,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 277.109 43.7982)",
    stroke: "url(#paint14_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.109,
    y: 0.463268,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 277.109 0.463268)",
    stroke: "url(#paint15_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.109,
    y: 87.4281,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 277.109 87.4281)",
    stroke: "url(#paint16_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.391,
    y: 43.7982,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 320.391 43.7982)",
    stroke: "url(#paint17_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.391,
    y: 0.463268,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 320.391 0.463268)",
    stroke: "url(#paint18_linear_1098_1863)",
    strokeWidth: 0.65516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.391,
    y: 87.4281,
    width: 30.0577,
    height: 30.0577,
    transform: "rotate(45 320.391 87.4281)",
    stroke: "url(#paint19_linear_1098_1863)",
    strokeWidth: 0.65516
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.239 64.4314C270.239 84.9003 266.683 101.494 262.297 101.494H279.063C283.45 101.494 287.005 84.9003 287.005 64.4314C287.005 43.9625 283.45 27.3691 279.063 27.3691H262.297C266.683 27.3691 270.239 43.9625 270.239 64.4314Z",
    fill: "url(#paint20_linear_1098_1863)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.244 64.4314C270.244 74.6915 269.35 83.9756 267.906 90.6864H284.673C286.116 83.9756 287.01 74.6915 287.01 64.4314C287.01 63.9113 286.998 63.4054 286.993 62.8896H270.227C270.231 63.4054 270.244 63.9113 270.244 64.4314Z",
    fill: "url(#paint21_linear_1098_1863)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M312.39 41.2676H247.531C244.973 41.2676 242.898 43.3418 242.898 45.9004V82.9627C242.898 85.5212 244.973 87.5955 247.531 87.5955H312.39C314.949 87.5955 317.023 85.5212 317.023 82.9627V45.9004C317.023 43.3418 314.948 41.2676 312.39 41.2676Z",
    fill: "url(#paint22_linear_1098_1863)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1098_1863",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 257,
    y: 29,
    width: 26,
    height: 75
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.15 29.2246H265.384C261.588 29.2246 258.419 41.6621 257.633 58.2747L265.841 63.3781L274.422 57.8701C275.24 41.4626 278.385 29.2246 282.15 29.2246ZM274.234 68.6472L265.841 73.9675L257.469 68.699C257.737 88.0382 261.173 103.35 265.385 103.35H282.151C277.935 103.349 274.496 88.0104 274.234 68.6472Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1098_1863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.382 41.2676H247.523C244.965 41.2676 242.891 43.3418 242.891 45.9004V82.9627C242.891 85.5212 244.965 87.5955 247.523 87.5955H312.382C314.941 87.5955 317.015 85.5212 317.015 82.9627V45.9004C317.015 43.3418 314.941 41.2676 312.382 41.2676Z",
    fill: "url(#paint23_linear_1098_1863)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297.443 78.2799V82.9621H293.004V78.6122C289.942 78.5016 286.99 77.6585 285.281 76.7035L286.635 71.3776C288.543 72.4209 291.229 73.3753 294.181 73.3753C296.755 73.3753 298.575 72.3326 298.575 70.5567C298.575 68.8475 297.088 67.7381 293.715 66.6065C288.855 64.9862 285.548 62.7001 285.548 58.3064C285.548 54.245 288.367 51.1157 293.227 50.2058V45.9004H297.665V49.8951C300.728 49.984 302.77 50.6715 304.301 51.4041L302.947 56.5305C301.815 55.9758 299.663 54.9331 296.401 54.9331C293.449 54.9331 292.495 56.2649 292.495 57.5293C292.495 58.9723 294.092 59.9705 297.955 61.3912C303.392 63.2999 305.522 65.7855 305.522 69.9353C305.521 73.9745 302.725 77.3694 297.443 78.2799Z",
    fill: "url(#paint24_linear_1098_1863)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M279.064 27.3691H262.297C258.501 27.3691 255.332 39.8066 254.547 56.4192L262.755 61.5227L271.336 56.0146C272.154 39.6071 275.3 27.3691 279.064 27.3691ZM271.148 66.7917L262.755 72.112L254.383 66.8436C254.651 86.1827 258.087 101.494 262.299 101.494H279.065C274.849 101.494 271.409 86.1549 271.148 66.7917Z",
    fill: "url(#paint25_linear_1098_1863)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1098_1863",
    x1: 0,
    y1: 65.0016,
    x2: 342.114,
    y2: 65.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1098_1863",
    x1: 171.057,
    y1: 0,
    x2: 171.057,
    y2: 130.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1098_1863",
    x1: 119.185,
    y1: 43.335,
    x2: 119.185,
    y2: 74.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1098_1863",
    x1: 119.185,
    y1: 0,
    x2: 119.185,
    y2: 30.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1098_1863",
    x1: 119.185,
    y1: 86.9648,
    x2: 119.185,
    y2: 117.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1098_1863",
    x1: 162.466,
    y1: 43.335,
    x2: 162.466,
    y2: 74.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1098_1863",
    x1: 162.466,
    y1: 0,
    x2: 162.466,
    y2: 30.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1098_1863",
    x1: 162.466,
    y1: 86.9648,
    x2: 162.466,
    y2: 117.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1098_1863",
    x1: 205.747,
    y1: 43.335,
    x2: 205.747,
    y2: 74.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1098_1863",
    x1: 205.747,
    y1: 0,
    x2: 205.747,
    y2: 30.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1098_1863",
    x1: 205.747,
    y1: 86.9648,
    x2: 205.747,
    y2: 117.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1098_1863",
    x1: 249.185,
    y1: 43.335,
    x2: 249.185,
    y2: 74.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1098_1863",
    x1: 249.185,
    y1: 0,
    x2: 249.185,
    y2: 30.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1098_1863",
    x1: 249.185,
    y1: 86.9648,
    x2: 249.185,
    y2: 117.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1098_1863",
    x1: 292.466,
    y1: 43.335,
    x2: 292.466,
    y2: 74.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1098_1863",
    x1: 292.466,
    y1: 0,
    x2: 292.466,
    y2: 30.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1098_1863",
    x1: 292.466,
    y1: 86.9648,
    x2: 292.466,
    y2: 117.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1098_1863",
    x1: 335.747,
    y1: 43.335,
    x2: 335.747,
    y2: 74.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1098_1863",
    x1: 335.747,
    y1: 0,
    x2: 335.747,
    y2: 30.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1098_1863",
    x1: 335.747,
    y1: 86.9648,
    x2: 335.747,
    y2: 117.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1098_1863",
    x1: 274.651,
    y1: 27.3692,
    x2: 274.651,
    y2: 101.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#F6BA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F7C676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#F8CF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5926,
    stopColor: "#F9D69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    stopColor: "#FADAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADBAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1098_1863",
    x1: 277.458,
    y1: 62.8898,
    x2: 277.458,
    y2: 90.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#F5B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2782,
    stopColor: "#F6BB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4872,
    stopColor: "#F6C16E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7156,
    stopColor: "#F7C578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C67B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1098_1863",
    x1: 242.898,
    y1: 64.4315,
    x2: 317.023,
    y2: 64.4315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F81D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1098_1863",
    x1: 242.891,
    y1: 64.4315,
    x2: 317.015,
    y2: 64.4315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6798E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E76D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1098_1863",
    x1: 285.281,
    y1: 64.4309,
    x2: 305.521,
    y2: 64.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCDDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1098_1863",
    x1: 266.723,
    y1: 27.3692,
    x2: 266.723,
    y2: 101.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2259,
    stopColor: "#FADAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#F9D69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5734,
    stopColor: "#F8CF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    stopColor: "#F7C676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8791,
    stopColor: "#F6BA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AE39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBgMobile);
export default __webpack_public_path__ + "static/media/medal_bg_mobile.7794d191a9d50a0f5bae2d6d20cb9f07.svg";
export { ForwardRef as ReactComponent };